export enum FacilitiesActions {
  LoadFacilities = 'Request data for facilities',
  LoadObjectFacilities = 'Request data for object facilities',
  SaveFacilities = 'Save data for object facilities',
  FacilitiesAccepted = 'Request data for facilities accepted',
  FacilitiesObjectAccepted = 'Request data for object facilities accepted',
}
